// Google Analytics utility functions
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

// Track page views
export const trackPageView = (path: string, title?: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-GK1LGG21M6', {
      page_path: path,
      page_title: title,
    });
  }
};

// Track custom events
export const trackEvent = (action: string, category: string, label?: string, value?: number) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track course interactions
export const trackCourseView = (courseId: string, courseName: string) => {
  trackEvent('view_course', 'engagement', `${courseId}: ${courseName}`);
};

export const trackBlogView = (articleId: string, articleTitle: string) => {
  trackEvent('view_article', 'blog', `${articleId}: ${articleTitle}`);
};